// extracted by mini-css-extract-plugin
module.exports = {"Container":"PhoneBlock_Container__86A8N","WrapperPopup":"PhoneBlock_WrapperPopup__kiuS1"};